import type { IconSvgObject } from './types';

const RotateSquareIcon: IconSvgObject = [
  ["path", { d: "M9.5 4.5L10.5858 3.41421C11.3668 2.63317 12.6332 2.63316 13.4142 3.41421L20.5858 10.5858C21.3668 11.3668 21.3668 12.6332 20.5858 13.4142L13.4142 20.5858C12.6332 21.3668 11.3668 21.3668 10.5858 20.5858L3.41421 13.4142C2.63317 12.6332 2.63316 11.3668 3.41421 10.5858L6.5 7.5H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default RotateSquareIcon;
